/**!
 * Created by Leonardo Cheslacki on 05/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import PageController from './PageController';

import {HelpersIcon} from './../helpers';

import config from '../../../../config';

const {default: {init: {frame}, view, button}} = config;

import WithType from './../helpers/WithType';

let _this = {};

/**
 * REVIEW helpersIcon in all fla for color.
 */
class PageCurrent extends PageController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {};

        this.$helpersIcon = HelpersIcon(this)({current_name: 'page'});

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         */
        handle: function (event) {

        }
    };

    /**
     * Not usage direct.
     * @param execute
     */
    defaultInit = (execute = null) => {
        const {current_name} = this.props;

        this.main.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        this.$helpersIcon.setIcon(this.get(), button.color_icon);

        (typeof (execute) === 'function') && execute();

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    /**
     * Not usage direct.
     * @param execute
     * @param dynamic
     * @param current_page
     */
    defaultPaginateInit = (execute = null, dynamic = false, current_page = null) => {
        const
            {current_name} = this.props,
            stagePaginate = this.main.$stagePaginate({current_name: current_name, current_page: current_page});

        this.main.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        stagePaginate.initPaginate(dynamic);

        this.$helpersIcon.setIcon(this.get(), button.color_icon);

        (typeof (execute) === 'function') && execute(stagePaginate);

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    /**
     * Single page.
     * Included helpersIcon color.
     */
    initCover = this.defaultInit;

    /**
     * Single page.
     * Included helpersIcon color.
     */
    initGallery = this.defaultInit;

    /**
     * Single page.
     * Included helpersIcon color.
     * For all pages simple.
     */
    initRecord = this.defaultInit;

    /**
     * Paginate.
     * Included helpersIcon color.
     * For all pages simple.
     */
    initPaginate = this.defaultPaginateInit;

    /**
     * Paginate.
     * Included helpersIcon color.
     */
    initLocalization = this.defaultPaginateInit;

    /**
     * Paginate.
     * Included helpersIcon color.
     */
    initDifferential = this.defaultPaginateInit;

    /**
     * Single page.
     * Included stagePin and helpersIcon color.
     */
    initImplantation = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            this.main.$stagePin({current_name: current_name}).initPin();
        });
    };

    /**
     * Single page.
     * Included stageSun and helpersIcon color.
     */
    initOrientation = () => {
        this.defaultInit(() => {
            const
                _this_frame = this.getFrame(),
                {current_name} = this.props;

            this.$helpersIcon.setIcon(_this_frame, button.color_icon);

            this.main.$stageSun({current_name: current_name}).initSun();
        });
    };

    /**
     * Paginate.
     * Included stagePaginate, layerDifferential, layerCamera, layerPin and helpersIcon color.
     * @param current_page
     */
    initPlants = (current_page) => {
        this.defaultPaginateInit((stagePaginate) => {
            const
                _this_current = this.get(),
                {current_name} = this.props,
                paginates = this.getObject(this.getCurrentIndex(), 'paginates'),
                paginate = this.getCurrentIndex(paginates) || this.getDefaultIndex(paginates),
                active_differential = this.verifyField(paginate, 'active.differential'),
                active_differential_enabled = this.verifyField(paginate, 'active.differential_enabled'),
                active_camera = this.verifyField(paginate, 'active.camera'),
                active_pin = this.verifyField(paginate, 'active.pin');

            if (active_differential) {
                const layerDifferential = this.main.$layerDifferential({
                    current_name: current_name,
                    current_page: current_page,
                    enabled: active_differential_enabled
                });
                layerDifferential.initDifferential();
                stagePaginate.setState({...stagePaginate.state, differential: layerDifferential});
            }

            if (active_camera) {
                const layerCamera = this.main.$layerCamera({current_name: current_name, current_page: current_page});
                layerCamera.initCamera();
                stagePaginate.setState({...stagePaginate.state, camera: layerCamera});
            }

            if (active_pin) {
                const layerPin = this.main.$layerPin({current_name: current_name, current_page: current_page});
                layerPin.initPin();
                stagePaginate.setState({...stagePaginate.state, pin: layerPin});
            }

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, button.color_icon, this.toNumber(property.name));
            }

            this.$helpersIcon.disabledAnimate(_this_current)(this.toNumber(current_page));
        }, false, current_page);
    };

    /**
     * Paginate.
     * Included stagePaginate, stageView and helpersIcon color.
     */
    initViews = () => {
        this.defaultPaginateInit(() => {
            const {current_name} = this.props;
            this.main.$stageView({current_name: current_name}).initView();
        }, true);
    };

    /**
     * Single page.
     * Included helpersIcon color.
     */
    initProject = () => {
        this.defaultInit(() => {
            const {occ_project: {occ_project_01, occ_project_02, occ_project_03}} = this.getFrame();

            this._handleProjectMore01 && occ_project_01.btn_more.off('mousedown', this._handleProjectMore01);
            this._handleProjectMore01 = occ_project_01.btn_more.on('mousedown', () => {
                (occ_project_02.currentLabel === 'complete') && occ_project_02.gotoAndPlay('complete');
                (occ_project_03.currentLabel === 'complete') && occ_project_03.gotoAndPlay('complete');

                occ_project_01.gotoAndPlay('start');
            });

            this._handleProjectLess01 && occ_project_01.btn_less.off('mousedown', this._handleProjectLess01);
            this._handleProjectLess01 = occ_project_01.btn_less.on('mousedown', () => {
                occ_project_01.gotoAndPlay('complete');
            });

            this.$helpersIcon.setIcon(occ_project_01, button.color_icon);

            this._handleProjectMore02 && occ_project_02.btn_more.off('mousedown', this._handleProjectMore02);
            this._handleProjectMore02 = occ_project_02.btn_more.on('mousedown', () => {
                (occ_project_01.currentLabel === 'complete') && occ_project_01.gotoAndPlay('complete');
                (occ_project_03.currentLabel === 'complete') && occ_project_03.gotoAndPlay('complete');

                occ_project_02.gotoAndPlay('start');
            });

            this._handleProjectLess02 && occ_project_02.btn_less.off('mousedown', this._handleProjectLess02);
            this._handleProjectLess02 = occ_project_02.btn_less.on('mousedown', () => {
                occ_project_02.gotoAndPlay('complete');
            });

            this.$helpersIcon.setIcon(occ_project_02, button.color_icon);

            this._handleProjectMore03 && occ_project_03.btn_more.off('mousedown', this._handleProjectMore03);
            this._handleProjectMore03 = occ_project_03.btn_more.on('mousedown', () => {
                (occ_project_01.currentLabel === 'complete') && occ_project_01.gotoAndPlay('complete');
                (occ_project_02.currentLabel === 'complete') && occ_project_02.gotoAndPlay('complete');

                occ_project_03.gotoAndPlay('start');
            });

            this._handleProjectLess03 && occ_project_03.btn_less.off('mousedown', this._handleProjectLess03);
            this._handleProjectLess03 = occ_project_03.btn_less.on('mousedown', () => {
                occ_project_03.gotoAndPlay('complete');
            });

            this.$helpersIcon.setIcon(occ_project_03, button.color_icon);
        });
    };

    /**
     * Single page.
     * Included stageZoom.
     */
    initPlant = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            this.main.$stageZoom({current_name: current_name}).initZoom();
        });
    };

    /**
     * Single page.
     * Included stageSlider.
     */
    initSlider = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            this.main.$stageSlider({current_name: current_name}).initSlider();
        });
    };

    /**
     * Single page.
     * Included stageScroll.
     */
    initScroll = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            this.main.$stageScroll({current_name: current_name}).initPin();
        });
    };

    /**
     * Single page.
     * Included stageQuiz.
     */
    initVertical = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            this.main.$stageQuiz({current_name: current_name}).initQuiz();
        });
    };

    /**
     *
     * @param current_page
     */
    initDeployments = (current_page) => {
        const
            _this_current = this.get(),
            {current_name} = this.props,
            stagePaginate = this.main.$stagePaginate({current_name: current_name, current_page: current_page}),
            stagePin = this.main.$stagePin({current_name: current_name});

        this.main.$current_name = current_name;

        this.gotoAndStopFrame(_this_current, frame);

        this.pageIn();

        this.$helpersIcon.disabledAnimate(_this_current)(this.toNumber(current_page));

        this.$helpersIcon.setIcon(_this_current, button.color_icon, 1);

        this.$helpersIcon.setIcon(_this_current, button.color_icon, 2);

        this.$helpersIcon.setIcon(_this_current, button.color_icon, 3);

        const object = this.getCurrentIndex();

        const
            paginates = this.getObject(object, 'paginates'),
            paginate = this.getCurrentIndex(paginates) || this.getDefaultIndex(paginates);

        stagePin.props.xml = this.verifyField(paginate, 'xml');
        stagePin.props.content_text = this.verifyField(paginate, 'content_text');

        stagePaginate.initPaginate();

        stagePin.initPin();

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    /**
     *
     * @param current_page
     * @param page
     */
    initDeploymentsAndOrientation = (current_page, page) => {
        const
            _this_current = this.get(),
            {current_name} = this.props,
            stagePaginate = this.main.$stagePaginate({current_name: current_name, current_page: current_page});

        this.main.$current_name = current_name;

        this.gotoAndStopFrame(_this_current, frame);

        this.$helpersIcon.disabledAnimate(_this_current)(this.toNumber(page));

        this.pageIn();

        if (page === 1) {
            const
                stagePin = this.main.$stagePin({current_name: current_name}),
                object = this.getCurrentIndex(),
                paginates = this.getObject(object, 'paginates'),
                paginate = this.getCurrentIndex(paginates) || this.getDefaultIndex(paginates);

            stagePin.props.xml = this.verifyField(paginate, 'xml');
            stagePin.props.content_text = this.verifyField(paginate, 'content_text');

            this.destroyTicker('_handleZoom');

            stagePin.initPin();
        } else if (page === 2) {
            const stageSun = this.main.$stageSun({current_name: current_name});

            this.destroyTicker('_handleZoom');

            stageSun.initSun();
        } else if (page === 3) {
            const stageZoom = this.main.$stageZoom({current_name: current_name});

            stageZoom.initZoom();
        }

        stagePaginate.initPaginate();

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    initSlide = () => {
        const
            _this_current = this.get(),
            {current_name} = this.props,
            stagePaginate = this.main.$stagePaginate({current_name: current_name}),
            occ_pseudo_frame = this.verifyField(_this_current, 'occ_pseudo_frame01'),
            btn_frame = this.verifyField(_this_current, 'btn_frame01');

        this.main.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        this.$helpersIcon.disabledAnimate(_this_current)(1, 'frame');

        this.$helpersIcon.setIcon(_this_current, button.color_icon, 1);

        this.$helpersIcon.setIcon(_this_current, button.color_icon, 2);

        occ_pseudo_frame && (occ_pseudo_frame.visible = true);

        btn_frame && (btn_frame.visible = false);

        stagePaginate.initPaginate(true);

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    initVideos = () => {
        const {current_name} = this.props;

        this.main.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        const {
            btm_video01,
            btm_video02,
            btm_video03,
            btm_video04,
            btm_video05,
            btm_video06,
            btm_video07,
            btm_video08,
            btm_video09,
            btm_video10,
            btm_video11
        } = this.getFrame();

        const execute = (event, options) => {
            let occ_button = this.getObject(options, 'occ_button');
            this.openVideo(occ_button, options);
        };

        this._handleVideo01 && btm_video01.off('mousedown', this._handleVideo01);
        this._handleVideo01 = btm_video01.on('mousedown', execute, false, false, {
            occ_button: btm_video01,
            name: 'video-01',
            uri: `${this.$base_uri}/public/media/perspectivas/empreendimento.mp4`
        });

        this._handleVideo02 && btm_video02.off('mousedown', this._handleVideo02);
        this._handleVideo02 = btm_video02.on('mousedown', execute, false, false, {
            occ_button: btm_video02,
            name: 'video-02',
            uri: `${this.$base_uri}/public/media/perspectivas/fachadaLateral.mp4`
        });

        this._handleVideo03 && btm_video03.off('mousedown', this._handleVideo03);
        this._handleVideo03 = btm_video03.on('mousedown', execute, false, false, {
            occ_button: btm_video03,
            name: 'video-03',
            uri: `${this.$base_uri}/public/media/perspectivas/giro360.mp4`
        });

        this._handleVideo04 && btm_video04.off('mousedown', this._handleVideo04);
        this._handleVideo04 = btm_video04.on('mousedown', execute, false, false, {
            occ_button: btm_video04,
            name: 'video-04',
            uri: `${this.$base_uri}/public/media/perspectivas/gourmet.mp4`
        });

        this._handleVideo05 && btm_video05.off('mousedown', this._handleVideo05);
        this._handleVideo05 = btm_video05.on('mousedown', execute, false, false, {
            occ_button: btm_video05,
            name: 'video-05',
            uri: `${this.$base_uri}/public/media/perspectivas/living1.mp4`
        });

        this._handleVideo06 && btm_video06.off('mousedown', this._handleVideo06);
        this._handleVideo06 = btm_video06.on('mousedown', execute, false, false, {
            occ_button: btm_video06,
            name: 'video-06',
            uri: `${this.$base_uri}/public/media/perspectivas/living2.mp4`
        });

        this._handleVideo07 && btm_video07.off('mousedown', this._handleVideo07);
        this._handleVideo07 = btm_video07.on('mousedown', execute, false, false, {
            occ_button: btm_video07,
            name: 'video-07',
            uri: `${this.$base_uri}/public/media/perspectivas/lobby.mp4`
        });

        this._handleVideo08 && btm_video08.off('mousedown', this._handleVideo08);
        this._handleVideo08 = btm_video08.on('mousedown', execute, false, false, {
            occ_button: btm_video08,
            name: 'video-08',
            uri: `${this.$base_uri}/public/media/perspectivas/piscina1.mp4`
        });

        this._handleVideo09 && btm_video09.off('mousedown', this._handleVideo09);
        this._handleVideo09 = btm_video09.on('mousedown', execute, false, false, {
            occ_button: btm_video09,
            name: 'video-09',
            uri: `${this.$base_uri}/public/media/perspectivas/piscina2.mp4`
        });

        this._handleVideo10 && btm_video10.off('mousedown', this._handleVideo10);
        this._handleVideo10 = btm_video10.on('mousedown', execute, false, false, {
            occ_button: btm_video10,
            name: 'video-10',
            uri: `${this.$base_uri}/public/media/perspectivas/piscina3.mp4`
        });

        this._handleVideo11 && btm_video11.off('mousedown', this._handleVideo11);
        this._handleVideo11 = btm_video11.on('mousedown', execute, false, false, {
            occ_button: btm_video11,
            name: 'video-11',
            uri: `${this.$base_uri}/public/media/perspectivas/portico.mp4`
        });

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    initSingle = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            this.main.$stageMemory({current_name: current_name}).initMemory();
        });
    };

    // initLocalization = () => {
    //     const
    //         {current_name} = this.props,
    //         _this_current = this.get(),
    //         stagePaginate = this.main.$stagePaginate({current_name: current_name}),
    //         occ_pseudo_frame = this.verifyField(_this_current, 'occ_pseudo_frame01'),
    //         btn_frame = this.verifyField(_this_current, 'btn_frame01'),
    //         children = this.verifyField(_this_current, 'occ_frame_03.occ_external.children');
    //
    //     this.main.$current_name = current_name;
    //
    //     this.gotoAndStopFrame(_this_current, frame);
    //
    //     this.pageIn();
    //
    //     this.$helpersIcon.disabledAnimate(_this_current)(1, 'frame');
    //
    //     this.$helpersIcon.setIcon(_this_current, button.color_icon, 1);
    //
    //     this.$helpersIcon.setIcon(_this_current, button.color_icon, 2);
    //
    //     this.$helpersIcon.setIcon(_this_current, button.color_icon, 3);
    //
    //     occ_pseudo_frame && (occ_pseudo_frame.visible = true);
    //
    //     btn_frame && (btn_frame.visible = false);
    //
    //     stagePaginate.initPaginate(true);
    //
    //     let external = {
    //         '01': {
    //             name: 'ALLTAP',
    //             uri: 'https://www.alltap.com.br'
    //         },
    //         '02': {
    //             name: 'ANIMATE CSS',
    //             uri: 'https://animate.style/'
    //         },
    //         '03': {
    //             name: 'BOOTSTRAP 5',
    //             uri: 'https://getbootstrap.com/docs/5.0/getting-started/introduction'
    //         },
    //         '04': {
    //             name: 'REACT JS',
    //             uri: 'https://pt-br.legacy.reactjs.org'
    //         },
    //         '05': {
    //             name: 'A-FRAME',
    //             uri: 'https://aframe.io'
    //         },
    //         '06': {
    //             name: 'CREATEJS',
    //             uri: 'https://createjs.com'
    //         },
    //         '07': {
    //             name: 'ADOBE ANIMATE',
    //             uri: 'https://www.adobe.com/br/products/animate.html'
    //         }
    //     }
    //
    //     if (this.isArrayIf(children)) {
    //         for (let property of children) {
    //             let
    //                 name = property.name,
    //                 number = this.toNumber(name),
    //                 occ = this.padWithLeadingZeros(number, 2);
    //
    //             this.openExternal(property, external[occ]);
    //         }
    //     }
    //
    //     /**
    //      * Preloader
    //      */
    //     this.main.emit('process_end', {}, current_name);
    // };
}

/**
 *
 * @type {{}}
 */
PageCurrent.propTypes = {
    current_name: PropTypes.string
};

/**
 *
 * @type {{}}
 */
PageCurrent.defaultProps = {
    current_name: null
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(PageCurrent, {className: 'PageCurrent'});
